const DefaultPaginationConfig = {
  initialDataState: { skip: 0, take: 20 },
  pageSizeValue: {
    buttonCount: 3,
    // pageSizes: [20],
  },
};

export default DefaultPaginationConfig;
